import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface AuthTransitionProps {
  children: ReactNode;
}

const AuthTransition = ({ children }: AuthTransitionProps) => {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayLocation, setDisplayLocation] = useState(location);

  useEffect(() => {
    if (location !== displayLocation) {
      setIsTransitioning(true);
      
      const timer = setTimeout(() => {
        setDisplayLocation(location);
        setIsTransitioning(false);
      }, 150);

      return () => clearTimeout(timer);
    }
  }, [location, displayLocation]);

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated Background - shared between both pages */}
      <div className="absolute inset-0 gradient-mesh">
        <div className="absolute top-20 left-20 w-72 h-72 bg-primary/20 rounded-full blur-3xl animate-float-slow" />
        <div className="absolute top-40 right-32 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-float-medium" />
        <div className="absolute bottom-32 left-1/3 w-80 h-80 bg-primary/10 rounded-full blur-3xl animate-float-fast" />
      </div>

      {/* Content with slide transition */}
      <div 
        className={`relative z-10 transition-all duration-300 ease-in-out transform ${
          isTransitioning 
            ? 'scale-95 opacity-0 translate-y-4' 
            : 'scale-100 opacity-100 translate-y-0'
        }`}
      >
        <div className="min-h-screen">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthTransition;
